import script from "./search-filter-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./search-filter-bar.vue?vue&type=script&setup=true&lang=js"

import "./search-filter-bar.vue?vue&type=style&index=0&id=ced53884&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ced53884"]])

export default __exports__